import React from 'react';
import { Button } from '../../../../components/button';
import { X } from 'lucide-react';

interface UnpublishedSurveyModalProps {
  isOpen: boolean;
  onPublish: () => void;
  onCancel: () => void;
  isPublished?: boolean;
}

const UnpublishedSurveyModal: React.FC<UnpublishedSurveyModalProps> = ({
  isOpen,
  onPublish,
  onCancel,
  isPublished = false
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 dark:bg-black/70 flex items-center justify-center z-50">
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg p-6 max-w-md w-full mx-4">
        {/* Header with title and close button */}
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
            {isPublished ? 'Survey Responses' : 'Unpublished Survey'}
          </h2>
          <button
            onClick={onCancel}
            className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 transition-colors"
          >
            <X className="h-5 w-5" />
          </button>
        </div>

        {/* Message */}
        <p className="text-gray-600 dark:text-gray-300 mb-6">
          {isPublished 
            ? 'Survey response data will be displayed here.' 
            : 'Please publish survey to view response data.'
          }
        </p>

        {/* Action buttons */}
        <div className="flex justify-end gap-3">
          <Button
            variant="outline"
            onClick={onCancel}
            className="px-4 py-2 text-gray-700 dark:text-gray-200 border-gray-300 dark:border-gray-600 hover:bg-gray-50 dark:hover:bg-gray-700"
          >
            Cancel
          </Button>
          <Button
            onClick={onPublish}
            className="px-4 py-2 text-white bg-[#00C29B] hover:bg-[#00b38a] dark:bg-[#00C29B] dark:hover:bg-[#00d4a8]"
          >
            Publish
          </Button>
        </div>
      </div>
    </div>
  );
};

export default UnpublishedSurveyModal;
